import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import EnhancedSkeleton from '../Summary/EnhancedSkeleton';
import { useTranslation } from 'react-i18next';

const LoadingScreen = ({ 
  title = "common.loadingData", 
  subtitle = "common.pleaseWait",
  showPreview = true 
}) => {
  const { t } = useTranslation();
  
  return (
    <Box sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      bgcolor: '#f5f5f5',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        gap: 3,
        maxWidth: 400,
        width: '90%'
      }}>
        <CircularProgress 
          size={60} 
          thickness={4}
          sx={{ 
            color: '#1976d2',
            mb: 2
          }} 
        />
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#333',
            fontWeight: 500,
            textAlign: 'center'
          }}
        >
          {t(title)}
        </Typography>
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#666',
            textAlign: 'center',
            lineHeight: 1.6
          }}
        >
          {t(subtitle)}
        </Typography>
        
        {showPreview && (
          <Box sx={{ 
            width: '100%', 
            mt: 3,
            p: 3,
            bgcolor: '#fff',
            borderRadius: 2,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}>
            <EnhancedSkeleton variant="text" width="60%" height={24} sx={{ mb: 2 }} animationType="power-pulse" />
            <EnhancedSkeleton variant="rectangular" width="100%" height={120} sx={{ mb: 2, borderRadius: 1 }} animationType="enhanced-wave" />
            <EnhancedSkeleton variant="text" width="80%" height={20} sx={{ mb: 1 }} animationType="gradient-flow" />
            <EnhancedSkeleton variant="text" width="90%" height={20} sx={{ mb: 1 }} animationType="shimmer" />
            <EnhancedSkeleton variant="text" width="70%" height={20} animationType="rainbow-wave" />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default LoadingScreen; 